<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li *ngFor="let item of breadcrumbItems; let i = index" class="breadcrumb-item" [class.active]="i === breadcrumbItems.length - 1">
        <span *ngIf="i !== breadcrumbItems.length - 1; else lastBreadcrumb" href="javascript:void(0)">{{ item }}</span>
        <ng-template #lastBreadcrumb>{{ item }}</ng-template>
      </li>
    </ol>
  </nav>